import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { makeId } from '../../../../utils/stringHelper';

const ZenPaymentContainer = ({
  cardFormVisible,
  onPay,
  paymentKey,
  amount,
  onSetButtonLoading,
}) => {
  const [oldPaymentKey, setOldPaymentKey] = useState(null);
  const navigate = useNavigate();
  const { slug, restaurantSlug } = useParams();

  const [, setPaymentId] = useState(null);
  const waitlessPaymentIdRef = useRef({ value: null }).current;
  const [currentPaymentTrackId, setCurrentPaymentTrackId] = useState(null);

  useEffect(() => {
    if (cardFormVisible) {
      setPaymentId(null);
      waitlessPaymentIdRef.value = null;

      // When amount is changed, use latest one
      const paymentTrackId = makeId(10);
      setCurrentPaymentTrackId(paymentTrackId);

      onSetButtonLoading(true);
      onPay({ paymentTrackId });
    }
  }, [cardFormVisible, amount]);

  const buildRedirectUrl = () => {
    if (slug && restaurantSlug) {
      return `/${slug}/${restaurantSlug}/payment`;
    }

    return '/payment';
  };

  useEffect(() => {
    if (paymentKey && currentPaymentTrackId) {
      if (!paymentKey.startsWith(currentPaymentTrackId)) {
        return;
      }

      const adjustedPaymentKey = paymentKey.replace(`${currentPaymentTrackId}~`, '');

      // If payment key was not updated
      if (adjustedPaymentKey === oldPaymentKey) {
        return;
      }

      // cache this payment key
      setOldPaymentKey(adjustedPaymentKey);

      const parts = adjustedPaymentKey.split('_||_');

      const callbacks = {
        cancelCallback: () => {
          onSetButtonLoading(false);
        },
        successCallback: () => {
          navigate(
            `${buildRedirectUrl()}?paymentId=${
              waitlessPaymentIdRef.value
            }&statusGroup=succeeded&custom=true`,
          );
        },
        failureCallback: () => {
          onSetButtonLoading(false);
        },
      };

      const configParams = {
        overlayBackgroundColor: 'rgba(0,0,0,0.32)',
        containerBackgroundColor: '#F7F6F8',
        containerBorderRadius: '10px',
        containerBorderColor: '1px solid #D3D4DC',
        containerBoxShadow: '0px 4px 34px 0px rgba(0, 0, 0, 0.25)',
        topBarBackgroundColor: '#FFFFFF',
        topBarFontColor: '#181818',
        topBarCloseIconColor: '#181818',
        inputBackgroundColor: '#FFFFFF',
        inputPrefixIconColor: '#b3b3b3',
        inputErrorColor: '#FF5622',
        inputFontColor: '#181818',
        inputPlaceholderFontColor: '#a8a8a8',
        inputBorderRadius: '3px',
        inputBorderColor: '1px solid #d3d4dc',
        inputBoxShadow: 'unset',
        buttonBackgroundColor: '#181818',
        buttonFontColor: '#FFFFFF',
        buttonBorderRadius: '100px',
        buttonBorderColor: 'unset',
        buttonBoxShadow: 'unset',
        fontAndIconColor: '#89829D',
        statusSuccessIconColor: '#0C8048',
        statusFailureIconColor: '#FF5622',
        statusPendingIconColor: '#0C8048',
        statusTextColor: '#181818',
      };

      const checkoutId = parts[0];
      const waitlessPaymentId = parts[1];

      setPaymentId(checkoutId);
      waitlessPaymentIdRef.value = waitlessPaymentId;

      const checkoutForm = new global.ZenCheckout(checkoutId, callbacks, configParams);
      checkoutForm.paymentPopup();
    }
  }, [paymentKey]);

  return <div />;
};

export default ZenPaymentContainer;
